module.exports = __webpack_public_path__ + "img/nav_arrow.501b492b.svg";